import "./Permissions.sass";
import PermissionCard from "./PermissionCard";
import { useEffect, useRef, useState } from "react";
import { getElements, putElement } from "services/apiEndpoints/Endpoints";

const UserPermission = ({state, dispatchUser}) => {
  const [permissions , setPermissions] = useState([])
  const [checkedPermission , setCheckedPermission] = useState("")
    // PERMISSIONS Array
  const permissionsArr = [
    {
      title: "Add Users",
      name: "userAdd",
    },
    {
      title: "Edit Users",
      name: "userEdit",
    },
    {
      title: "Manage Permissions",
      name: "userRoleManage",
    },
    {
      title: "Add Operators",
      name: "freightOperatorAdd",
    },
    {
      title: "Edit Operators",
      name: "freightOperatorEdit",
    },
    {
      title: "Manage Transport Operators",
      name: "transportOperatorManage",
    },
    {
      title: "Manage Logistics Operators",
      name: "logisticsOperatorManage",
    },
  ];
   const getPermission = () => {
    getElements(`/Admin/User/${state.userId}/Permission`).then((res) => {
      setPermissions(res.data)
    })
   }
   // Tranck first render 
   const isFirstRender = useRef(true);

   useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;  
  }

  //after user changes permissions
  put();
}, [checkedPermission]);

   // PUT permission
   const put = () => {
    putElement(`/Admin/User/${state.userId}/Permission`, checkedPermission, "", {ignoreToast:true}).then((res) => {})
   }


   useEffect(getPermission , [])
  return (
    <div className="ema-card mt-0">
      <div className="permisions_header-contianer">
        <p className="Permissions_header_title">Permissions</p>
        <p className="Permissions_header_title">Access</p>
      </div>
      <di>
        {permissionsArr.map((per) => {
          return (
            <PermissionCard
              permissions = {permissions}
              title={per.title}
              name={per.name}
              setCheckedPermission= {setCheckedPermission}
              setPermissions={setPermissions}
            />
          );
        })}
      </di>
    </div>
  );
};

export default UserPermission;
